// import { useEffect, forwardRef } from "react";
// import css from "./popUp.module.css";

// const PopUpRada = forwardRef(
//   ({ popupPosition, scrollHeight }, ref, onClick) => {
//     return (
//       <div className={css.musicWrapOpNew} ref={ref} onClick={onClick}>
//         <p className={css.mainPopP}>
// Опікун — це читач, що зацікавився книжкою, готовий прочитати її в
// електронному форматі (pdf) та написати щирий змістовний відгук.
// <br /> Опікун отримує:
// <br /> - безплатний pdf-примірник книжки;
// <br /> - 40% знижки на будь-яку кількість друкованих примірників цієї
// книжки протягом року;
// <br /> - бонусні "слони" за відгук (1 "слон" = 1 грн при замовленні
// книжок на сайті).
//         </p>
//       </div>
//     );
//   }
// );

// export default PopUpRada;
// src/components/PopUpRada.jsx
import React, { forwardRef } from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // підправ свій шлях
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "opikun_rada_info"; // Док у колекції "popups"
// Назва: "Що таке опікунська рада"

const PopUpRada = forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      if (!snap.exists()) {
        setHtml("");
        return;
      }
      setHtml(snap.data()?.contentHtml || "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={`${css.musicWrapOpNew} `} ref={ref} onClick={onClick}>
      <div
        className={`${css.mainPopP} `}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopUpRada;
